/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Upload_OptionalInputs */

const cs_pm_upload_optional = /** @type {(inputs: Pm_Upload_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`…nebo nahrát export místo API`)
};

const en_pm_upload_optional = /** @type {(inputs: Pm_Upload_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`…or upload an export instead of the API`)
};

/**
* | output |
* | --- |
* | "…or upload an export instead of the API" |
*
* @param {Pm_Upload_OptionalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_upload_optional = /** @type {((inputs?: Pm_Upload_OptionalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Upload_OptionalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_upload_optional(inputs)
	return cs_pm_upload_optional(inputs)
});